import { type Conversation } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import type { ChatStoreAction } from './types';

/**
 * Util action to initialize conversation with conversationId
 */
export const initializeConversationData =
	({ conversationId, data }: { conversationId: string; data: Conversation }): ChatStoreAction =>
	({ getState, setState }) => {
		setState({
			conversations: {
				...getState().conversations,
				[conversationId]: {
					...getState().conversations[conversationId],
					...data,
				},
			},
		});
	};
